/* eslint-disable no-unused-vars */
import alert from '@/plugins/alert'
import { Lead, CountStatus, CountSucceed, LeadProgress } from '@/plugins/api'

const defaultLeadStatusCount = () => ({
  countAll: 0,
  countNoContact: 0,
  countAppointmentSet: 0,
  countProductVerified: 0,
  countSucceed: 0,
  countFailed: 0,
})

export default {
  namespaced: true,
  state: {
    Leads: [],
    count: 0,
    item: {},
    importedItems: [],
  },
  actions: {
    async fetchLeads({ commit }, options) {
      try {
        const leads = await Lead.fetch({ ...options, _sort: 'createdAt:DESC' })
        commit('setLeads', leads)
        return leads
      } catch (e) {
        alert.error(e)
      }
    },
    fetchLeadIndependent(_, options) {
      return Lead.fetch({ ...options, _sort: 'createdAt:DESC' })
    },
    async fetchLead({ commit }, leadId) {
      const item = await Lead.fetchOne(leadId)
      commit('changeState', { item })
      return item
    },
    countLeads(_, options) {
      try {
        return Lead.count(options)
      } catch (e) {
        alert.error(e)
      }
    },
    createLead(_, data) {
      return Lead.create(data)
    },
    updateLead(_, { id, ...leadData }) {
      return Lead.update(id, { ...leadData })
    },
    countStatus(_, options) {
      return CountStatus.fetch({ ...options })
    },
    countSucceed(_, options) {
      return CountSucceed.fetch({ ...options })
    },
    async fetchLeadTableData({ dispatch }, { selectedTab = 'all', query = {}, pagination = {} } = {}) {
      const page = pagination.page || 1
      const itemsPerPage = pagination.itemsPerPage || 10
      const start = itemsPerPage === -1 ? 0 : (page - 1) * itemsPerPage
      const baseQueryParams = { isArchived: 'false' }
      const tableQueryParams = { ...baseQueryParams }
      if (selectedTab !== 'all') tableQueryParams.status = selectedTab

      const statusCountParams = { ...baseQueryParams, ...query }
      delete statusCountParams.status

      const tableQuery = { ...tableQueryParams, ...query }
      const [totalItems, leads, statusCount] = await Promise.all([
        dispatch('countLeads', tableQuery),
        dispatch('fetchLeads', { _start: start, _limit: itemsPerPage, ...tableQuery }),
        dispatch('countStatus', statusCountParams),
      ])
      const leadList = leads || []
      const appointmentsByLead = await dispatch(
        'appointment/fetchLatestAppointmentsByLead',
        { leadIds: leadList.map(lead => lead.id), query },
        { root: true }
      )

      return {
        totalItems: totalItems || 0,
        leads: leadList,
        statusCount: statusCount || defaultLeadStatusCount(),
        appointmentsByLead,
      }
    },
    async fetchLeadProgress(_, options) {
      const progress = await LeadProgress.fetch({ ...options })
      return progress[0]
    },
    updateLeadProgress(_, { id, ...data }) {
      return LeadProgress.update(id, { ...data })
    },
    setImportedItems({ commit }, importedItems) {
      commit('changeState', { importedItems })
    },
  },
  mutations: {
    setLeads(state, Leads) {
      state.Leads = Leads.reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [`${currentValue.id}`]: currentValue,
        }),
        {}
      )
    },
  },
  getters: {
    Leads: state => Object.values(state.Leads),
    item: state => state.item,
    importedItems: state => state.importedItems,
  },
}
/* eslint-enable no-unused-vars */
